<template>
    <div
        :style="{ 'border-color': footer.borderColor, color: footer.fontColor }"
        class="flex flex-col sm:flex-row items-center justify-between py-6 text-base"
        :class="[!footer.simple ? 'mt-8 border-t' : '']"
    >
        <div class="mb-2 sm:mb-0">
            <cUtilsEdit @edit="goToContentField('footerCopyrights')">
                <p>© {{ new Date().getFullYear() + " " + footer.copyrights }}</p>
            </cUtilsEdit>
        </div>
        <c-address
            class="mb-2 sm:mb-0"
            v-if="!footer.simple && footer.contactInfo && footer.contactLayout == 'row'"
            :footer="footer"
        />
        <c-terms :footer="footer" />
    </div>
</template>

<script>
import CAddress from "./cAddress.vue";
import cTerms from "./cTerms.vue";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";
import { useLegalGoTo } from "@/views/tools/legal/utils/useLegalGoTo";

export default {
    name: "cCopyTerms",
    components: {
        cTerms,
        CAddress,
        cUtilsEdit,
    },
    setup() {
        const { goToContentField } = useLegalGoTo();
        return {
            goToContentField,
        };
    },
    props: {
        footer: Object,
    },
};
</script>
